import {
  EventCategoryDetail,
  EventCategoryFullListItem,
  EventCategoryShortListItem,
} from 'model/modules/events/eventCategory';
import { mapEventListItemFromApi } from './mapEventListFromApi';

export const mapShortEventCategories = (
  resp: ApiListResponse<ApiEventTypeListItem>
): RemoteList<EventCategoryShortListItem> => {
  return {
    items: resp.items.map((apiItem) => ({
      id: apiItem.id,
      name: apiItem.name,
      icon: apiItem.icon.url ?? '',
    })),
  };
};

export const mapFullEventCategories = (
  resp: ApiListResponse<ApiEventTypeFullListItem>
): RemoteList<EventCategoryFullListItem> => {
  return {
    items: resp.items.map((apiItem) => ({
      id: apiItem.id,
      name: apiItem.name,
      icon: apiItem.icon.url ?? '',
      events: apiItem.events.map(mapEventListItemFromApi),
    })),
  };
};

const mapEventCategoryFromApi = (resp: ApiEventType): EventCategoryDetail => {
  return {
    id: resp.id,
    name: resp.name,
    topics: resp.topics.map((topic) => ({
      title: topic.name,
      subtitle: topic.subtitle,
      icon: topic.icon.url ?? '',
    })),
    directions: resp.directions,
    feedbacks: resp.feedbacks.map((feedback) => ({
      clientName: feedback.client_name,
      videoUrl: feedback.video_url,
      description: feedback.description,
    })),
    icon: resp.icon.url ?? '',
    hasNextEvent: resp.has_next_event,
    nextEvent: resp.next_event
      ? mapEventListItemFromApi(resp.next_event)
      : null,
    nextEvents: resp.next_events.map(mapEventListItemFromApi),
    prevEvents: resp.prev_events.map(mapEventListItemFromApi),
  };
};

export default mapEventCategoryFromApi;
